<template>
    <div>404</div>
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {},
    methods: {},
    created() {},
};
</script>
<style lang="scss">
</style>